import { useQuery } from '@tanstack/react-query'
import { isToday, parseISO } from 'date-fns'
import { useEffect, useState } from 'react'

import { Breadcrumb } from '../../../components/Breadcumb'
import { CleanReport, getReportsWithoutPagination, toggleTradeMarketingDailyCheck } from '../../../services/reportServices'
import { DailyReportCard } from './components/dailyReportCard'
import { DailyReportCardSkeleton } from './components/dailyReportCardSkeleton'

export function TradeMarketingDailyCheck() {
  const [reports, setReports] = useState<CleanReport[]>([])

  const { data, refetch, isLoading } = useQuery({
    queryKey: ['trade_marketing_daily_reports'],
    queryFn: async () => {
      const { reports } = await getReportsWithoutPagination({})
      return reports ?? []
    },
  })

  async function handleToggleTradeMarketingDailyCheck(reportId: string) {
    const result = await toggleTradeMarketingDailyCheck(reportId)
    if (result) {
      if (result.success) {
        refetch()
      }
    }
  }

  useEffect(() => {
    if (data) {
      const sortedReports = data.sort((a, b) => {
        const dateA = a.trade_marketing_check_date
          ? typeof a.trade_marketing_check_date === 'string'
            ? parseISO(a.trade_marketing_check_date)
            : a.trade_marketing_check_date
          : new Date(0)
        const dateB = b.trade_marketing_check_date
          ? typeof b.trade_marketing_check_date === 'string'
            ? parseISO(b.trade_marketing_check_date)
            : b.trade_marketing_check_date
          : new Date(0)

        const isDateAToday = a.trade_marketing_check_date && isToday(dateA)
        const isDateBToday = b.trade_marketing_check_date && isToday(dateB)

        if (isDateAToday && !isDateBToday) return 1
        if (!isDateAToday && isDateBToday) return -1

        if (!a.trade_marketing_check_date && b.trade_marketing_check_date) return -1
        if (a.trade_marketing_check_date && !b.trade_marketing_check_date) return 1

        if (a.trade_marketing_check_date && b.trade_marketing_check_date) {
          return dateB.getTime() - dateA.getTime()
        }

        return a.store.name.localeCompare(b.store.name)
      })

      setReports(sortedReports)
    }
  }, [data])

  return (
    <div className="min-h-screen">
      <div className="flex flex-col mx-auto max-w-screen-lg">
        <div className="px-2 lg:px-0 my-4">
          <Breadcrumb
            items={[
              { label: 'Dashboard', path: '/dashboard' },
              { label: 'Diário de Trade Marketing', path: '/trade-marketing-daily-check' },
            ]}
          />
        </div>
        <header className="flex flex-col sm:flex-row justify-between items-center m-4 lg:mx-0">
          <h1
            className="mb-4 sm:mb-0 font-bold text-2xl"
          >
            Diário de Trade Marketing
          </h1>
        </header>
        <main className="md:mt-6 space-y-2">
          {!isLoading
            ? reports
              .map((report) => (
                <DailyReportCard
                  key={report.id}
                  report={report}
                  handleToggleTradeMarketingDailyCheck={handleToggleTradeMarketingDailyCheck}
                />
              ))
            : (
                Array.from({ length: 5 }).map((_, index) => (
                  <DailyReportCardSkeleton key={index} />
                ))
              )}
        </main>
      </div>
    </div>
  )
}
